import { useMediaQuery } from 'react-responsive';
import { CrossIcon } from 'components/Icons/CrossIcon';
import aboutApeMobile1 from 'img/about/aboutApe480@1x.png';
import aboutApeMobile2 from 'img/about/aboutApe480@2x.png';
import aboutApeTablet1 from 'img/about/aboutApe768@1x.png';
import aboutApeTablet2 from 'img/about/aboutApe768@2x.png';
import aboutApeDesktop1 from 'img/about/aboutApe1280@1x.png';
import aboutApeDesktop2 from 'img/about/aboutApe1280@2x.png';

import css from './AboutSection.module.css';

export const AboutSection = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

  return (
    <section id="#about">
      <div className={css.sectionContainer}>
        {isMobile ? (
          <div className={css.contentBox}>
            <h2 className={css.aboutTitle}>
              a Story that started with
              <span className={css.accentColor}>
                one simple <br /> ape
              </span>
            </h2>
            <div className={css.contentContainer}>
              <span>WHO GOT</span>
              <span>FED UP WITH BORING</span>
              <span>AND HYPOCRITIC</span>
              <span>COMMONPLACE THIS IS</span>
              <span>HOW THE IDEA OF</span>
              <span>ESCAPING AND DYNAMIC</span>
              <span>JOURNEY ON THE YACHT</span>
            </div>
            <div className={css.containerCross}>
              <CrossIcon />
            </div>
            <div className={css.textContainer}>
              <span>EACH ARTWORK IN THE</span>
              <span>COLLECTION TELLS A STORY OF</span>
              <span>ONE JOURNEY. ARTS ARE</span>
              <span>RANDOMLY GENERATED BY USERS</span>
            </div>
            <div className={css.aboutImage}>
              <picture>
                <source
                  srcSet={`${aboutApeMobile1} 1x, ${aboutApeMobile2} 2x`}
                  media="(max-width: 480px)"
                  sizes="max-width: 292px"
                />
                <img
                  src={aboutApeMobile1}
                  alt="The monkey in glasses and a cap"
                  loading="lazy"
                />
              </picture>
            </div>
          </div>
        ) : (
          <div className={css.contentBox}>
            <div>
              <h2 className={css.aboutTitle}>
                a Story <br /> that <br /> started <br /> with
                <span className={css.accentColor}>
                  one <br /> simple ape
                </span>
              </h2>
              <div className={css.containerCross}>
                <CrossIcon />
              </div>
              <div className={css.textContainer}>
                <span>EACH ARTWORK IN THE</span>
                <span>COLLECTION TELLS A STORY OF</span>
                <span>ONE JOURNEY. ARTS ARE</span>
                <span>RANDOMLY GENERATED BY USERS</span>
              </div>
              </div>              
              <div>
              <div className={css.contentContainer}>
              <span>WHO GOT FED UP WITH BORING</span>
              <span>AND HYPOCRITIC COMMONPLACE</span>
              <span>THIS IS HOW THE IDEA OF</span>
              <span>ESCAPING AND DYNAMIC</span>
              <span>JOURNEY ON THE</span>
              <span>YACHT</span>
            </div>
            <div className={css.aboutImage}>
              <picture>
                <source
                  srcSet={`${aboutApeDesktop1} 1x, ${aboutApeDesktop2} 2x`}
                  media="(min-width: 1280px)"
                  sizes="min-width: 492px"
                />
                <source
                  srcSet={`${aboutApeTablet1} 1x, ${aboutApeTablet2} 2x`}
                  media="(min-width: 768px)"
                  sizes="min-width: 313px 100vw, 313px"
                />
                <img
                  src={aboutApeMobile1}
                  alt="The monkey in glasses and a cap"
                  loading="lazy"
                />
              </picture>
              </div>  
            </div>                          
          </div>
        )}
      </div>
    </section>
  );
};
